import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PencilSVG from 'core/icons/PencilSVG';
import TrashSVG from 'core/icons/TrashSVG';

import {
	QuestionAdminButton,
	QuestionAdminLink,
} from './questionsStyles';

class AdminTools extends PureComponent {
	render() {
		const { isAdmin, questionId, onDelete } = this.props;
		if (!isAdmin) return null;
		return (
			<div>
				<QuestionAdminLink href={`/a/questions/${questionId}`} rel="noopener noreferrer" target="_blank" title={`This icon only appears to CJ Admins.`}>
					<PencilSVG />
				</QuestionAdminLink>
				<QuestionAdminButton onClick={(e) => onDelete(e, questionId)} title={`This icon only appears to CJ Admins.`}>
					<TrashSVG />
				</QuestionAdminButton>
			</div>
		);
	}
}

AdminTools.propTypes = {
	isAdmin: PropTypes.bool,
	questionId: PropTypes.number.isRequired,
	onDelete: PropTypes.func.isRequired,
};

AdminTools.defaultProps = {
	isAdmin: false,
};

export default AdminTools;
